import {
    AppBar, Toolbar, Typography, Box, Container,
    Button, Avatar, Chip, Tooltip
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV_LINKS = [
    { label: 'Crear Material', path: '/' },
    { label: 'Materiales Creados', path: '/materiales-creados' },
];

const Header = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const getInitials = (nombre) => {
        if (!nombre) return '?';
        return nombre.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    const isActive = (path) => location.pathname === path;

    return (
        <AppBar
            position="static"
            color="default"
            elevation={0}
            sx={{ backgroundColor: '#ffffff', borderBottom: '1px solid rgba(0, 0, 0, 0.10)' }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ justifyContent: 'space-between', minHeight: '70px !important' }}>

                    {/* Logo + navegación */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                        <Box
                            component="img"
                            src={`${process.env.PUBLIC_URL}/assets/Talsa-Logo.jpg`}
                            alt="Talsa Logo"
                            sx={{ height: 40, objectFit: 'contain', cursor: 'pointer' }}
                            onClick={() => navigate('/')}
                        />

                        {/* Nav links */}
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
                            {NAV_LINKS.map(link => (
                                <Button
                                    key={link.path}
                                    onClick={() => navigate(link.path)}
                                    size="small"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: isActive(link.path) ? 700 : 500,
                                        color: isActive(link.path) ? '#D32F2F' : '#475569',
                                        borderRadius: 2,
                                        px: 1.5,
                                        borderBottom: isActive(link.path) ? '2px solid #D32F2F' : '2px solid transparent',
                                        '&:hover': { bgcolor: '#fef2f2', color: '#D32F2F' }
                                    }}
                                >
                                    {link.label}
                                </Button>
                            ))}
                        </Box>
                    </Box>

                    {/* Derecha: usuario + config + logout */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>

                        {/* Botón configuración — solo admin */}
                        {user?.rol === 'admin' && (
                            <Tooltip title="Configuración de usuarios">
                                <Button
                                    size="small"
                                    startIcon={<SettingsIcon fontSize="small" />}
                                    onClick={() => navigate('/configuracion')}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: isActive('/configuracion') ? 700 : 500,
                                        color: isActive('/configuracion') ? '#D32F2F' : '#475569',
                                        borderRadius: 2,
                                        borderBottom: isActive('/configuracion') ? '2px solid #D32F2F' : '2px solid transparent',
                                        '&:hover': { bgcolor: '#fef2f2', color: '#D32F2F' }
                                    }}
                                >
                                    Configuración
                                </Button>
                            </Tooltip>
                        )}

                        {/* Chip usuario */}
                        {user && (
                            <Tooltip title={user.email || ''}>
                                <Chip
                                    avatar={
                                        <Avatar sx={{ bgcolor: '#D32F2F', fontSize: '0.72rem', fontWeight: 700 }}>
                                            {getInitials(user.nombre)}
                                        </Avatar>
                                    }
                                    label={user.nombre || user.email}
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: '0.85rem',
                                        borderColor: 'rgba(0,0,0,0.15)',
                                        '& .MuiChip-label': { px: 1.2 }
                                    }}
                                />
                            </Tooltip>
                        )}

                        {/* Logout */}
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            startIcon={<LogoutIcon fontSize="small" />}
                            onClick={handleLogout}
                            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 500 }}
                        >
                            Salir
                        </Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
